/* BlueTruck24 hub theme — core behaviour. Vanilla, no dependencies.
   Mirrors the interactive parts of the Hydrogen storefront (Aside, cart,
   predictive search, wishlist). Config comes from window.BT_CONFIG (theme.liquid). */
(function () {
  'use strict';

  var config = window.BT_CONFIG || {};
  var routes = config.routes || {};
  var BT = (window.BT = window.BT || {});

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  // ── Money ────────────────────────────────────────────────────────────────
  BT.money = function (cents) {
    var format = config.moneyFormat || '€{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function fmt(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        default: return fmt(2, ',', '.');
      }
    });
  };

  // ── Aside (cart / search drawers) ────────────────────────────────────────
  var FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var activeAside = null;
  var previousFocus = null;

  BT.aside = {
    open: function (type) {
      var el = $('[data-bt-aside="' + type + '"]');
      if (!el) return;
      if (activeAside && activeAside !== el) BT.aside.close();
      previousFocus = document.activeElement;
      el.hidden = false;
      activeAside = el;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        var first = $(type === 'search' ? 'input[type="search"]' : FOCUSABLE, $('[role="dialog"]', el));
        if (first) first.focus();
      });
    },
    close: function () {
      if (!activeAside) return;
      activeAside.hidden = true;
      activeAside = null;
      document.documentElement.style.overflow = '';
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    },
  };

  document.addEventListener('keydown', function (event) {
    if (!activeAside) return;
    if (event.key === 'Escape') return BT.aside.close();
    if (event.key !== 'Tab') return;
    var focusable = $all(FOCUSABLE, $('[role="dialog"]', activeAside));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // ── Cart ─────────────────────────────────────────────────────────────────
  function json(url, options) {
    return fetch(url, Object.assign({headers: {'Content-Type': 'application/json', Accept: 'application/json'}}, options)).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw Object.assign(new Error(body.description || body.message || 'Cart error'), {body: body});
        return body;
      });
    });
  }

  function cartSections() {
    var ids = ['bt-cart-drawer'];
    var page = $('[data-bt-cart-section]');
    if (page) ids.push(page.getAttribute('data-bt-cart-section'));
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'bt-cart-drawer') {
        var body = $('[data-bt-cart-drawer-body]');
        var fresh = $('[data-bt-cart-drawer-body]', doc);
        if (body && fresh) body.innerHTML = fresh.innerHTML;
      } else {
        var target = $('[data-bt-cart-section="' + id + '"]');
        var next = $('[data-bt-cart-section="' + id + '"]', doc);
        if (target && next) target.innerHTML = next.innerHTML;
      }
    });
  }

  function paintCart(cart) {
    $all('[data-bt-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
      if (el.hasAttribute('data-bt-hide-zero')) el.hidden = cart.item_count === 0;
    });
    var source = $('[data-bt-cart-total-source]');
    var total = source ? source.textContent : BT.money(cart.total_price);
    $all('[data-bt-cart-total]').forEach(function (el) {
      el.textContent = total;
    });
    document.dispatchEvent(new CustomEvent('bt:cart:updated', {detail: cart}));
  }

  BT.cart = {
    refresh: function () {
      return Promise.all([
        json(routes.cart + '.js'),
        fetch(window.location.pathname + '?sections=' + cartSections().join(',')).then(function (r) { return r.json(); }),
      ]).then(function (results) {
        applySections(results[1]);
        paintCart(results[0]);
        return results[0];
      });
    },
    add: function (items, options) {
      return json(routes.cartAdd + '.js', {method: 'POST', body: JSON.stringify({items: [].concat(items), sections: cartSections()})}).then(function (result) {
        applySections(result.sections);
        return json(routes.cart + '.js').then(function (cart) {
          paintCart(cart);
          if (options && options.openDrawer) BT.aside.open('cart');
          return cart;
        });
      });
    },
    change: function (key, quantity) {
      return json(routes.cartChange + '.js', {method: 'POST', body: JSON.stringify({id: key, quantity: quantity, sections: cartSections()})}).then(function (cart) {
        applySections(cart.sections);
        paintCart(cart);
        return cart;
      });
    },
    discount: function (code) {
      return json(routes.cartUpdate + '.js', {method: 'POST', body: JSON.stringify({discount: code, sections: cartSections()})}).then(function (cart) {
        applySections(cart.sections);
        paintCart(cart);
        return cart;
      });
    },
  };

  function productFormItem() {
    var form = $('form[data-bt-product-form]');
    if (!form) return null;
    var id = form.elements.id && form.elements.id.value;
    if (!id) return null;
    var quantity = form.elements.quantity ? Number(form.elements.quantity.value) || 1 : 1;
    return {id: Number(id), quantity: quantity};
  }

  function busy(el, state) {
    if (!el) return;
    if (state) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
    el.disabled = state ? true : el.hasAttribute('data-bt-unavailable');
  }

  function checkoutUrl() {
    return routes.root.replace(/\/$/, '') + '/checkout';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('form[data-bt-product-form]')) {
      var action = event.submitter && event.submitter.getAttribute('data-bt-action');
      var item = productFormItem();
      if (!item) return;
      event.preventDefault();
      busy(event.submitter, true);
      BT.cart.add(item, {openDrawer: action !== 'buy-now'}).then(function () {
        if (action === 'buy-now') window.location.href = checkoutUrl();
      }).catch(function (error) {
        window.alert(error.message);
      }).then(function () {
        busy(event.submitter, false);
      });
    } else if (form.matches('form[data-bt-mailto-form]')) {
      // Hydrogen does not post this form anywhere: it opens the visitor's mail client
      // with the message pre-filled, then reveals the address. Same behaviour here.
      event.preventDefault();
      var value = function (name) {
        var input = form.elements.namedItem(name);
        return input ? input.value : '';
      };
      var message = 'Name: ' + value('name') + '\nEmail: ' + value('email') + '\nPhone: ' + value('phone') + '\n\n' + value('message');
      window.location.href = 'mailto:' + form.getAttribute('data-email') +
        '?subject=' + encodeURIComponent(form.getAttribute('data-subject') || '') +
        '&body=' + encodeURIComponent(message);
      var sent = $('[data-bt-mailto-sent]', form);
      if (sent) sent.hidden = false;
    } else if (form.matches('form[data-bt-discount-form]')) {
      event.preventDefault();
      var code = (form.elements.discountCode.value || '').trim();
      if (code) BT.cart.discount(code).catch(function () {});
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-bt-open],[data-bt-close],[data-bt-cart-change],[data-bt-discount-remove],[data-bt-buy-now],[data-bt-add-to-cart-quiet],[data-bt-focus-search],[data-bt-menu-button],[data-bt-dropdown-button],[data-bt-wishlist],[data-bt-back-to-top],[data-bt-toggle]');
    if (!target) {
      $all('[data-bt-dropdown-list]').forEach(function (list) { list.hidden = true; });
      return;
    }
    if (target.hasAttribute('data-bt-open')) {
      BT.aside.open(target.getAttribute('data-bt-open'));
    } else if (target.hasAttribute('data-bt-close')) {
      BT.aside.close();
    } else if (target.hasAttribute('data-bt-cart-change')) {
      target.disabled = true;
      BT.cart.change(target.getAttribute('data-bt-cart-change'), Number(target.getAttribute('data-quantity'))).catch(function () { target.disabled = false; });
    } else if (target.hasAttribute('data-bt-discount-remove')) {
      BT.cart.discount('').catch(function () {});
    } else if (target.hasAttribute('data-bt-buy-now') || target.hasAttribute('data-bt-add-to-cart-quiet')) {
      var item = productFormItem();
      if (!item) return;
      var buyNow = target.hasAttribute('data-bt-buy-now');
      busy(target, true);
      BT.cart.add(item, {openDrawer: false}).then(function () {
        if (buyNow) window.location.href = checkoutUrl();
      }).catch(function (error) {
        window.alert(error.message);
      }).then(function () {
        busy(target, false);
      });
    } else if (target.hasAttribute('data-bt-focus-search')) {
      var input = document.getElementById('header-search-input');
      if (input) {
        input.focus();
        input.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    } else if (target.hasAttribute('data-bt-menu-button')) {
      var menu = $('[data-bt-menu]');
      var open = menu.hidden;
      menu.hidden = !open;
      target.setAttribute('aria-expanded', String(open));
      $('[data-bt-menu-icon-open]', target).hidden = open;
      $('[data-bt-menu-icon-close]', target).hidden = !open;
    } else if (target.hasAttribute('data-bt-dropdown-button')) {
      var list = $('[data-bt-dropdown-list]', target.closest('[data-bt-dropdown]'));
      list.hidden = !list.hidden;
      target.setAttribute('aria-expanded', String(!list.hidden));
    } else if (target.hasAttribute('data-bt-wishlist')) {
      event.preventDefault();
      BT.wishlist.toggle(target.getAttribute('data-bt-wishlist'));
    } else if (target.hasAttribute('data-bt-back-to-top')) {
      window.scrollTo({top: 0, behavior: 'smooth'});
    } else if (target.hasAttribute('data-bt-toggle')) {
      var panel = document.getElementById(target.getAttribute('data-bt-toggle'));
      if (panel) {
        panel.hidden = !panel.hidden;
        target.setAttribute('aria-expanded', String(!panel.hidden));
      }
    }
  });

  // ── Predictive search ────────────────────────────────────────────────────
  $all('[data-bt-predictive]').forEach(function (widget) {
    var input = $('[data-bt-predictive-input]', widget);
    var panel = $('[data-bt-predictive-panel]', widget);
    var inline = widget.hasAttribute('data-bt-predictive-inline');
    if (!input || !panel) return;
    var timer = null;
    var controller = null;
    var idle = panel.innerHTML;

    function show(state) {
      if (!inline) panel.hidden = !state;
    }

    function run() {
      var term = input.value.trim();
      if (!term) {
        panel.innerHTML = idle;
        show(false);
        return;
      }
      show(true);
      panel.innerHTML = '<p class="py-6 text-center text-sm text-ink-muted">' + (config.strings && config.strings.searching || '…') + '</p>';
      if (controller) controller.abort();
      controller = new AbortController();
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,page,article&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=hide&section_id=bt-predictive-search';
      fetch(url, {signal: controller.signal}).then(function (response) { return response.text(); }).then(function (html) {
        var fresh = $('[data-bt-predictive-results]', new DOMParser().parseFromString(html, 'text/html'));
        if (fresh) panel.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim()) show(true);
    });
    widget.addEventListener('focusout', function (event) {
      if (inline || widget.contains(event.relatedTarget)) return;
      setTimeout(function () { show(false); }, 150);
    });
  });

  // ── Wishlist (same localStorage key as the Hydrogen storefront) ──────────
  var WISHLIST_KEY = 'bluetruck-wishlist';
  function readWishlist() {
    try {
      var parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(handles) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
    } catch (e) { /* private mode / quota */ }
    paintWishlist();
    document.dispatchEvent(new CustomEvent('bt:wishlist:updated', {detail: handles}));
  }
  function paintWishlist() {
    var handles = readWishlist();
    $all('[data-bt-wishlist-count]').forEach(function (el) {
      el.textContent = handles.length > 99 ? '99+' : String(handles.length);
      el.hidden = handles.length === 0;
    });
    $all('[data-bt-wishlist]').forEach(function (el) {
      var active = handles.indexOf(el.getAttribute('data-bt-wishlist')) !== -1;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', String(active));
      var icon = $('svg', el);
      if (icon) icon.setAttribute('fill', active ? 'currentColor' : 'none');
      if (config.strings) {
        var text = active ? config.strings.removeFromWishlist : config.strings.addToWishlist;
        el.setAttribute('aria-label', text);
        el.setAttribute('title', text);
        var label = $('[data-bt-wishlist-label]', el);
        if (label) label.textContent = text;
      }
    });
  }
  BT.wishlist = {
    all: readWishlist,
    count: function () { return readWishlist().length; },
    has: function (handle) { return readWishlist().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var handles = readWishlist();
      var index = handles.indexOf(handle);
      if (index === -1) handles.push(handle);
      else handles.splice(index, 1);
      writeWishlist(handles);
      return index === -1;
    },
    clear: function () { writeWishlist([]); },
    repaint: paintWishlist,
  };
  window.addEventListener('storage', paintWishlist);
  paintWishlist();

  // ── Back to top ──────────────────────────────────────────────────────────
  var backToTop = $('[data-bt-back-to-top]');
  if (backToTop) {
    var onScroll = function () { backToTop.hidden = window.scrollY <= 400; };
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
  }
})();
